var _defs, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrickCement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Grupo_11914",
    width: 36.229,
    height: 31.125,
    viewBox: "0 0 36.229 31.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#09c}.cls-2{fill:#272727}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11910",
    transform: "translate(6.102 5.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11888",
    transform: "translate(0.218 0.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11595",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4532",
    d: "M0 0H12.347V6.217H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11891",
    transform: "translate(12.57 0.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11601",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4535",
    d: "M0 0H12.424V6.217H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11895",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11609",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25913",
    d: "M68.609 317.2H55.828v-6.651h12.781zm-12.347-.434h11.913v-5.786H56.262z",
    className: "cls-2",
    transform: "translate(-55.828 -310.546)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11898",
    transform: "translate(12.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11615",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25916",
    d: "M82.908 317.2H70.049v-6.652h12.859zm-12.425-.434h11.991v-5.783H70.483z",
    className: "cls-2",
    transform: "translate(-70.049 -310.544)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11911",
    transform: "translate(1.743 12.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11889",
    transform: "translate(20.116 0.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11597",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4533",
    d: "M0 0H14.154V6.217H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11892",
    transform: "translate(5.565 0.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11603",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4536",
    d: "M0 0H14.552V6.214H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11893",
    transform: "translate(0.218 0.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11605",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4537",
    d: "M0 0H5.346V6.214H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11896",
    transform: "translate(19.899 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11611",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25914",
    d: "M93.327 324.355H78.74V317.7h14.587zm-14.153-.434h13.719v-5.783H79.174z",
    className: "cls-2",
    transform: "translate(-78.74 -317.704)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11899",
    transform: "translate(5.348 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11617",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25917",
    d: "M76.971 324.353H61.984v-6.647h14.987zm-14.553-.434h14.119v-5.779H62.418z",
    className: "cls-2",
    transform: "translate(-61.984 -317.706)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11900",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11619",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25918",
    d: "M61.609 324.353h-5.781v-6.647h5.781zm-5.347-.434h4.912v-5.779h-4.912z",
    className: "cls-2",
    transform: "translate(-55.828 -317.706)"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11913",
    transform: "translate(1.743 24.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11901",
    transform: "translate(20.116 0.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11621",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4539",
    d: "M0 0H14.154V6.217H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11902",
    transform: "translate(5.565 0.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11623",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4540",
    d: "M0 0H14.552V6.214H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11903",
    transform: "translate(0.218 0.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11625",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4541",
    d: "M0 0H5.346V6.214H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11904",
    transform: "translate(19.899 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11627",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25919",
    d: "M93.327 338.665H78.74v-6.65h14.587zm-14.153-.434h13.719v-5.782H79.174z",
    className: "cls-2",
    transform: "translate(-78.74 -332.015)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11905",
    transform: "translate(5.348 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11629",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25920",
    d: "M76.971 338.664H61.984v-6.648h14.987zm-14.553-.434h14.119v-5.779H62.418z",
    className: "cls-2",
    transform: "translate(-61.984 -332.017)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11906",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11631",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25921",
    d: "M61.609 338.664h-5.781v-6.648h5.781zm-5.347-.434h4.912v-5.779h-4.912z",
    className: "cls-2",
    transform: "translate(-55.828 -332.017)"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11912",
    transform: "translate(6.102 18.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11890",
    transform: "translate(12.57 0.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11599",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4534",
    d: "M0 0H12.424V6.214H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11894",
    transform: "translate(0.218 0.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11607",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4538",
    d: "M0 0H12.347V6.214H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11897",
    transform: "translate(12.352 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11613",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25915",
    d: "M82.908 331.508H70.049v-6.648h12.859zm-12.425-.434h11.991v-5.78H70.483z",
    className: "cls-2",
    transform: "translate(-70.049 -324.86)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11907",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11633",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25922",
    d: "M68.609 331.508H55.828v-6.648h12.781zm-12.347-.434h11.913v-5.78H56.262z",
    className: "cls-2",
    transform: "translate(-55.828 -324.86)"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11908",
    transform: "translate(1.345 1.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25923",
    d: "M52.265 311.724a.435.435 0 0 1-.375-.653 9.538 9.538 0 0 1 5.731-4.349.434.434 0 0 1 .251.831 8.7 8.7 0 0 0-5.231 3.955.435.435 0 0 1-.376.216z",
    className: "cls-2",
    transform: "translate(-51.831 -306.702)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11909",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25924",
    d: "M50.714 309.862a.434.434 0 0 1-.374-.652 9.538 9.538 0 0 1 5.73-4.35.434.434 0 1 1 .251.831 8.7 8.7 0 0 0-5.231 3.956.434.434 0 0 1-.376.215z",
    className: "cls-2",
    transform: "translate(-50.281 -304.84)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrickCement);
export default __webpack_public_path__ + "static/media/brick-cement.a54027ca5443c5519b6fa5619dc35571.svg";
export { ForwardRef as ReactComponent };